import type { BeforeSend } from "./utils";

export const ignoreErrors = [
  /iframe adapter timedout/i,
  /request has been terminated/i,
] satisfies (string | RegExp)[];

export const ignoreWithBeforeSend: BeforeSend = (event, hint) => {
  if (isPubnubError(event.exception) || isPubnubError(hint.originalException)) {
    return null;
  }

  return event;
};

function isPubnubError(error: unknown) {
  return (
    error &&
    error instanceof Error &&
    "isPubnubError" in error &&
    error.isPubnubError
  );
}
